/* PHP version registry — the versions php.onl ships (7.2–8.5).
 *
 * PHP 5.6 dropped: @php-wasm minimum is 7.2 (5.6 wasm binaries don't exist).
 *
 * `sizeMB` is the measured asyncify .wasm size (MiB) shown in the picker for
 * un-cached versions; cached versions report real bytes from Cache Storage.
 * `full` mirrors the binaries shipped by @php-wasm/web-<ver> packages. */
export type VersionTag = '' | 'latest' | 'eol';

export interface PhpVersion {
  /** major.minor key, e.g. "8.4". */
  v: string;
  /** full display version, e.g. "8.4.7". */
  full: string;
  /** badge tag. */
  tag: VersionTag;
  /** short headline feature, shown as a note. */
  note: string;
  /** provisional WASM size in MB (see file header). */
  sizeMB: number;
}

export const PHP_VERSIONS: PhpVersion[] = [
  { v: '8.5', full: '8.5.6', tag: 'latest', note: 'Pipe operator, clone with', sizeMB: 23.0 },
  { v: '8.4', full: '8.4.20', tag: '', note: 'Property hooks', sizeMB: 21.9 },
  { v: '8.3', full: '8.3.30', tag: '', note: 'Typed class constants', sizeMB: 20.4 },
  { v: '8.2', full: '8.2.30', tag: '', note: 'Readonly classes', sizeMB: 20.1 },
  { v: '8.1', full: '8.1.34', tag: 'eol', note: 'Enums, fibers', sizeMB: 19.8 },
  { v: '8.0', full: '8.0.30', tag: 'eol', note: 'JIT, match()', sizeMB: 16.4 },
  { v: '7.4', full: '7.4.33', tag: 'eol', note: 'Arrow functions', sizeMB: 16.2 },
  { v: '7.3', full: '7.3.33', tag: 'eol', note: 'Flexible heredoc', sizeMB: 19.3 },
  { v: '7.2', full: '7.2.34', tag: 'eol', note: 'Object type hint', sizeMB: 19.3 },
];

/** Single version on first load protects LCP (avoids parallel wasm downloads). */
export const DEFAULT_VERSION = '8.4';

const byKey = new Map(PHP_VERSIONS.map((x) => [x.v, x]));

/** Fallback to `<v>.0` when version is not in the registry. */
export function verFull(ver: string): string {
  return byKey.get(ver)?.full ?? `${ver}.0`;
}

/** Order selected versions by the registry's canonical order. */
export function orderVersions(selected: string[]): string[] {
  return PHP_VERSIONS.map((x) => x.v).filter((v) => selected.includes(v));
}
